import * as CONSTS from 'redux/constants';

export const setCardToPay = card => ({
  type: CONSTS.SET_CARD_TO_PAY,
  payload: { card }
});

export const createPaymentFail = e => ({
  type: CONSTS.CREATE_PAYMENT_FAIL,
  payload: { error: e }
});

export const setCardFormView = data => ({
  type: CONSTS.SET_CARD_FORM_VIEW,
  payload: { view: data }
});

export const initCardForm = data => ({
  type: CONSTS.INIT_CARD_FORM,
  payload: { form: data }
});

export const initCardFormAddress = data => ({
  type: CONSTS.INIT_CARD_FORM_ADDRESS,
  payload: { formAddress: data }
});

export const resetCardForm = () => ({
  type: CONSTS.RESET_CARD_FORM
});

export const onChangeCardForm = ({ fieldPath, value, isCheckbox }) => ({
  type: CONSTS.ON_CHANGE_CARD_FORM,
  payload: { fieldPath, value, isCheckbox }
});

export const setCardFormError = ({ fieldPath, errorMessage }) => ({
  type: CONSTS.SET_CARD_FORM_ERROR,
  payload: { fieldPath, errorMessage }
});
export const submitCardForm = data => ({
  type: CONSTS.SET_SUBMIT_CARD_FORM,
  payload: { submit: data }
});

export const submitEditForm = data => ({
  type: CONSTS.SET_SUBMIT_EDIT_FORM,
  payload: { submit: data, isEdit: true }
});

export const setSelectedCard = data => ({
  type: CONSTS.SET_SELECTED_CARD,
  payload: { card: data }
});

export const clearCardFormErrors = ({ fieldsPath }) => ({
  type: CONSTS.CLEAR_CARD_FORM_ERRORS,
  payload: { fieldsPath }
});

export const updateEditFormPristine = pristine => ({
  type: CONSTS.UPDATE_EDIT_PRISTINE,
  payload: { pristine }
});

export const clearCustomerAddressTouched = () => ({
  type: CONSTS.CLEAR_CUSTOMER_ADDRESS_TOUCHED
});

export const updateCardForm = data => ({
  type: CONSTS.UPDATE_CARD_FORM,
  payload: { pmtAdditionalFields: data }
});

export const touchAllCardForm = () => ({
  type: CONSTS.TOUCH_ALL
});

export const touchCardFormAddress = () => ({
  type: CONSTS.TOUCH_ADDRESS
});

export const clearAllCardFormErrors = () => ({
  type: CONSTS.CLEAR_ALL_CARD_FORM_ERRORS
});

export const clearAllCardFormTouched = () => ({
  type: CONSTS.CLEAR_ALL_CARD_FORM_TOUCHED
});
